import React, { useState } from "react";
import { Button } from "antd";
import { ShrinkOutlined, ArrowsAltOutlined } from "@ant-design/icons";
import Header from "./header";
import LeftMenu from "./SidebarMenu/LeftMenu";
import Navigation from "./navigation";
import NavigationAttributes from "./navigationAttributes";
import AuditLogs from "./navigationAuditLogs";
import NavigationNewToStrum from "./navigationNewToStrum";
import { Routes, Route, Navigate } from "react-router-dom";

const Layout = ({ onLogout }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [globalList, setGlobalList] = useState(null);

  const toggleCollapsed = () => {
    setCollapsed(prev => !prev);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }} className="MainBox">
      <Header onLogout={onLogout} collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      <div className="MainBody">
        <div className="MainInnerBody">
          <div className="container">
            <div className="containerRow">
              <div className="LeftCol" style={{ width: collapsed ? 80 : 256 }}>
                <div className="LeftMenuBtnBox">
                  <Button
                    className="LeftMenuBtn"
                    onClick={toggleCollapsed}
                    style={{ marginRight: 16 }}
                  >
                    {collapsed ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
                  </Button>
                </div>
                <LeftMenu collapsed={collapsed} />
              </div>

              <div
                className="RightCol"
                style={{
                  paddingLeft: `${collapsed ? 120 : 296}px`,
                  transition: "padding-left 0.3s"
                }}
              >
                <Routes>
                  <Route index element={<Navigate to="home" replace />} />
                  <Route path="home" element={<Navigation globalList={globalList} setGlobalList={setGlobalList} />} />
                  <Route path="kits" element={<Navigation globalList={globalList} setGlobalList={setGlobalList} />} />
                  <Route path="bundles" element={<Navigation globalList={globalList} setGlobalList={setGlobalList} />} />
                  <Route path="simple_products" element={<Navigation globalList={globalList} setGlobalList={setGlobalList} />} />
                  <Route path="sample-promotion-products" element={<Navigation globalList={globalList} setGlobalList={setGlobalList} />} />
                  <Route path="variants" element={<Navigation globalList={globalList} setGlobalList={setGlobalList} />} />

                  <Route path="attributes" element={<NavigationAttributes globalList={globalList} setGlobalList={setGlobalList} />} />
                  <Route path="new-to-strum" element={<NavigationNewToStrum />} />
                  <Route path="audit_logs" element={<AuditLogs globalList={globalList} setGlobalList={setGlobalList} />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
